import React from "react";
import { valueIsNotInFilteredData } from "select2-react-component";
export const LJRCoinFormatter = (values) => {
  console.log('LJRCoinFormatter----------->:', values)
  let str = ''
  if (values.length > 0) {

    values.map((valC, ind) => {
      if (ind == 0) {
        str = valC.currencyName + "(" + valC.amount + ")"
      } else {
        str = str + " , " + valC.currencyName + "(" + valC.amount + ")"
      }
    })
  } else {
    str = "-"
  }
  return str;
}
export const LJRAmountFormatter = (values) => {
  let str = ''
  if (values.length > 0) {

    values.map((valC, ind) => {
      if (ind == 0) {
        str = valC.amount
      } else {
        str = str + " , " + valC.amount
      }
    })
  } else {
    str = "-"
  }
  return str;
}

export const PlatformFormatter = (values) => {
  if (values.length > 0){
    return values.join(", ")
  }
  return '-';
}
export const LJRCurrencyFormatter = (values) => {
  let str = ''
  if (values.length > 0) {

    values.map((valC, ind) => {
      // console.log("LJRCurrencyFormatter",valC);
      if (ind == 0) {
        str = valC?.currencyName || valC?.inCurrency?.label
      } else {
        let NextCurrency = valC?.currencyName || valC?.inCurrency?.label
        str = str + " , " + NextCurrency
      }
    })
  } else {
    str = "-"
  }
  return (
    <span
        className={`text-capitalize`}
    >
      {str}
    </span>
  );
}

export const WinningCurrencyFormatter = (values) => {
  let str = ''
  if (values.length > 0) {

    values.map((valC, ind) => {
      if (ind == 0) {
        str = valC?.currencyName || valC?.outCurrency?.label
      } else {
        let NextCurrency = valC?.currencyName || valC?.outCurrency?.label
        str = str + " , " + NextCurrency
      }
    })
  } else {
    str = "-"
  }
  return (
    <span
        className={`text-capitalize`}
    >
      {str}
    </span>
  );
}

export const LJRCurrencyFormatterObj = (values) => {
  let str = 0
  if(values)
  {
    return values?.LJRAmount || 0
  }
  return str;
}

export const winningCurrencyFormatterObj = (values) => {
  let str = 0
  if(values)
  {
    return values?.winningAmount || 0
  }
  return str;
}

export const CompanyFormatter = (values) => {
  let str = ''
  if (values.length > 0) {

    values.map((valC, ind) => {
      if (ind == 0) {
        str = valC?.selectedCompany?.label
      } else {
        let NextCurrency = valC?.selectedCompany?.label
        str = str + " , " + NextCurrency
      }
    })
  } else {
    str = "-"
  }
  return str;
}


export const isScheduledByPartnerFormatter = (values) => {
 if(values!=null&&values){
  return "Partner";
 }else
  return "GamerJi E-Sports"
 
  
}

export const remainingPlayersFormatter = (cell, row) => {
    const totalPlayers = parseInt(row.totalPlayers) || 0;
   const totalJoinedPlayers = parseInt(row.totalJoinedPlayers) || 0;
  return totalPlayers - totalJoinedPlayers;
   
 }
 
export const LJRTournamentFormatter = (cell, row) => {
 
  const totalPlayers = parseInt(row.entryFee) || 0;
 const totalJoinedPlayers = parseInt(row.totalJoinedPlayers) || 0;
return totalPlayers * totalJoinedPlayers;
 
}